module.exports = __webpack_public_path__ + "img/1529148531.e7582d5b.jpg";